import { render, staticRenderFns } from "./NewProfilePicker.vue?vue&type=template&id=46253b92&scoped=true"
import script from "./NewProfilePicker.vue?vue&type=script&lang=js"
export * from "./NewProfilePicker.vue?vue&type=script&lang=js"
import style0 from "./NewProfilePicker.vue?vue&type=style&index=0&id=46253b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46253b92",
  null
  
)

export default component.exports